import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import awsmobile from './aws-exports';
import StolenItemReport from './pages/StolenItemReport';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import PaymentPage from './pages/PaymentPage';
import AdditionalInfoPage from './pages/AdditionalInfoPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import StatusPage from './pages/StatusPage';
import Test from './pages/Test';
import NotFoundPage from './pages/NotFoundPage';
import Header from './components/Header';
import './sass/main.scss';

// import Footer from './components/Footer';
import { ErrorBoundary } from 'react-error-boundary';
import { Amplify } from 'aws-amplify';
import HomePage from './pages/HomePage';
import { isUserLogged } from './functions/userFuncs';
import Auth from '@aws-amplify/auth';

Amplify.configure(awsmobile);
Auth.configure(awsmobile);

const App: React.FC = () => {
  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    isUserLogged(setIsLogged);
  }, [isUserLogged, setIsLogged]);

  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <Router>
        {/* <Header isLogged={isLogged} logUser={setIsLogged} /> */}
        <Routes>
          <Route path='/' element={<HomePage isLogged={isLogged} />} />
          {/* <Route path='/report-stolen-item' element={<StolenItemReport />} /> */}
          {/* <Route path="/chose-item" element={<ChoseItem />} /> */}
          <Route
            path='/login'
            element={<LoginPage logUser={setIsLogged} isLogged={isLogged} />}
          />
          <Route path='/signup' element={<SignUpPage isLogged={isLogged} />} />
          <Route path='/payment/:itemID' element={<PaymentPage />} />
          <Route path='/additional-info' element={<AdditionalInfoPage />} />
          <Route
            path='/status/*'
            element={<StatusPage isLogged={isLogged} logUser={setIsLogged} />}
          />
          <Route path='/forgot-password' element={<ForgotPasswordPage />} />
          <Route path='/stolen-report-item' element={<Test />} />
          <Route path="*" element={<NotFoundPage/>} />

        </Routes>
        {/* <Footer /> */}
      </Router>
    </ErrorBoundary>
  );
};

export default App;
